/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 91bea3268d1c4691912d52ca9d6840c972076fbd0d467b3c4f271b7bb9b9a7b6
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Tooltip.style'

type TooltipOwnProps = {
  className?: string
  children: React.ReactNode
  placement?: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end' | 'right' | 'right-start' | 'right-end'
  showCarrot?: boolean
}

export type TooltipProps = TooltipOwnProps & Omit<ComponentProps<'div'>, keyof TooltipOwnProps>

function Tooltip(props: TooltipProps): ReactElement {
  const {
    children,
    className = '',
    placement = 'top',
    showCarrot = true,
    ...rest
  } = props

  return (
    <div
      className={cn('Tooltip', className, placement, { showCarrot })}
      css={style}
      {...rest}
      role={rest.role ?? 'tooltip'}
    >
      {children}
    </div>
  )
}

export default Tooltip
